module.exports = __webpack_public_path__ + "img/tecnicosc.897aecb0.png";